var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.version)?_c('span',{staticClass:"text-body-2 font-weight-light"},[_vm._v(_vm._s(_vm.version.version))]):_vm._e(),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":20}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }